import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'messageContentAsHtml'
})
export class MessageContentAsHtmlPipe implements PipeTransform {
  constructor() {}

  transform(content: string): string {
    const textAreaElement = document.createElement('textarea');
    textAreaElement.innerHTML = unescape(content);

    return textAreaElement.value;
  }
}
